import React from "react";

const MissionVision = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        {/* Heading */}
        <h2 className="text-2xl font-semibold text-gray-900 mb-8">
          Mission & vision
        </h2>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Mission */}
          <div className="border border-gray-200 rounded-xl p-6 bg-[#FBFBFB]">
            <h4 className="font-semibold text-gray-900 mb-2">Our mission</h4>
            <p className="text-gray-600 mb-6">
              Give every B2B company predictable cash flow without the
              complexity of traditional financing.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-[15px] border border-[#f1dede] rounded-[8px] flex flex-col gap-[7px]">
                <p className="text-xl font-semibold text-gray-900">$500M+</p>
                <p className="text-sm text-gray-500">Invoices assessed</p>
              </div>
              <div className="bg-white p-[15px] border border-[#f1dede] rounded-[8px] flex flex-col gap-[7px]">
                <p className="text-xl font-semibold text-gray-900">45+</p>
                <p className="text-sm text-gray-500">Industries served</p>
              </div>
            </div>
          </div>

          {/* Vision */}
          <div className="border border-gray-200 rounded-xl p-6 bg-[#FBFBFB]">
            <h4 className="font-semibold text-gray-900 mb-2">Our vision</h4>
            <p className="text-gray-600 mb-6">
              A real-time liquidity layer embedded in the tools businesses
              already use.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white p-[15px] border border-[#f1dede] rounded-[8px] flex flex-col gap-[7px]">
                <p className="text-xl font-semibold text-gray-900">🌍</p>
                <p className="text-sm text-gray-500">Operating in EU & UK</p>
              </div>
              <div className="bg-white p-[15px] border border-[#f1dede] rounded-[8px] flex flex-col gap-[7px]">
                <p className="text-xl font-semibold text-gray-900">99.95%</p>
                <p className="text-sm text-gray-500">Platform uptime</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default MissionVision;
